/**
 * Module dependencies.
 */

import { AxiosInstance } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * Verify email.
 */

function verifyEmail(client: AxiosInstance, token: string): Promise<void> {
  return client.post(resolveAppUrl('verifyEmail'), { token }).then(({ data }) => data);
}

/**
 * `Options` type.
 */

type Options = UseMutationOptions<void, unknown, string, unknown>;

/**
 * Export `useVerifyEmail`.
 */

export function useVerifyEmail(options?: Options) {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (token: string) => {
      return await verifyEmail(client, token);
    },
    ...options
  });
}
